import { SearchNormal } from "pages/support-tickets/icons";
import styles from "./styles.module.scss";
import { PrioritySelect } from "../priority-select";
import { issueTypeArr, priorityArr } from "./constants";

export function TicketsSearchFilter({
  setSearchVal,
  searchVal,
  handleChangeTicketPreference,
  handleChangeIssueType,
}: any) {
  function handleChange() {}
  return (
    <div className={styles.ticketsSearchFilter}>
      <div className={styles.searchField}>
        <span className={styles.icon}>
          <SearchNormal />
        </span>
        <input
          type="text"
          className={styles.input}
          placeholder="Search For Ticket"
          onChange={(e: any) => setSearchVal(e.target.value)}
          value={searchVal}
        />
      </div>

      <div className={styles.dropdownsContainer}>
        <PrioritySelect
          options={issueTypeArr}
          placeholder="Issue Type"
          onChange={handleChangeIssueType}
          variant="ticket-preference"
        />
        <PrioritySelect
          options={priorityArr}
          placeholder="Select Priority"
          onChange={handleChangeTicketPreference}
          variant="ticket-preference"
        />
        <PrioritySelect
          options={[
            { label: "All Time", value: "all-time" },
            { label: "This Week", value: "this-week" },
            { label: "This Month", value: "this-month" },
            { label: "Last Month", value: "last-month" },
            { label: "Last 6 Months", value: "last-6-months" },
            { label: "Last 1 Year", value: "last-1-year" },
          ]}
          placeholder="Range"
          onChange={handleChange}
          variant="date-select"
        />
      </div>
    </div>
  );
}
